import Cookies from 'js-cookie';

const AUTH_TOKEN_KEY = 'token';

export function getAuthToken() {
  return Cookies.get(AUTH_TOKEN_KEY);
}

export function removeAuthToken() {
  Cookies.remove(AUTH_TOKEN_KEY);
}

export function setAuthToken(token) {
  Cookies.set(AUTH_TOKEN_KEY, token);
}
